import { render, staticRenderFns } from "./MenusContainerView.vue?vue&type=template&id=c359fb7e&"
import script from "./MenusContainerView.vue?vue&type=script&lang=js&"
export * from "./MenusContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports